const GlobalLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Page Content */}
      <div className="flex-1">{children}</div>

      {/* Global Footer */}
      {/* <Footer /> */}
    </div>
  );
};

export default GlobalLayout;
